import { column_components } from "./column.components";
import { table_defaults } from "./templates";
export const column_defaults = column_components;
export class Table {
  static Default = table_defaults.default;
  static Edit = table_defaults.edit;
  static View = table_defaults.view
  static Static = table_defaults.static;
  static Index =  table_defaults.index;
  static Common = table_defaults.common;

  static Column = column_components
}
